import ClientModule from "@gqlapp/module-client-react";
import Route from "@lib/Route";
import List from "@modules/article/components/list";
import {defaultRoute, getProps} from "@modules/article/helpers/config";

export default new ClientModule({
	route:{ TaxonomyCategory: <Route {...getProps(defaultRoute, List, { classNameOnPage: 'taxonomy taxonomy-article' })} /> }
});
